import { useAuthStore } from '../../stores/auth';
import { useCircleStore } from '../../stores/circle';
import { toast } from '../ui/Toast';

export function MemberList() {
  const me = useAuthStore((s) => s.user);
  const members = useCircleStore((s) => s.members);
  const online = useCircleStore((s) => s.onlineMembers);
  const removeMember = useCircleStore((s) => s.removeMember);
  const transferOwnership = useCircleStore((s) => s.transferOwnership);
  const isOwner = members.find((m) => m.user_id === me?.id)?.role === 'owner';

  async function onRemove(userId: string, name: string) {
    if (!window.confirm(`Remove ${name} from circle?`)) return;
    try {
      await removeMember(userId);
      toast(`${name} removed`, 'success');
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Could not remove', 'error');
    }
  }

  async function onTransfer(userId: string, name: string) {
    if (!window.confirm(`Make ${name} the owner? You will become a regular member immediately.`)) return;
    try {
      await transferOwnership(userId);
      toast(`${name} is now the owner`, 'success');
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Could not transfer ownership', 'error');
    }
  }

  return (
    <ul className="divide-y divide-border-subtle rounded-2xl border border-border-subtle bg-card">
      {members.map((m) => (
        <li key={m.user_id} className="flex items-center justify-between gap-3 px-4 py-3">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-surface text-sm font-medium text-text-primary">
              {m.display_name.slice(0, 1).toUpperCase()}
            </div>
            <div>
              <div className="text-sm text-text-primary">
                {m.display_name}{m.user_id === me?.id ? ' (you)' : ''}
              </div>
              <div className="text-xs text-text-muted flex items-center gap-1.5">
                <span className={`inline-block h-1.5 w-1.5 rounded-full ${online.has(m.user_id) ? 'bg-sage' : 'bg-border-strong'}`} />
                {m.role === 'owner' ? 'Owner' : 'Member'}
              </div>
            </div>
          </div>
          {isOwner && m.user_id !== me?.id && m.role !== 'owner' && (
            <div className="flex flex-shrink-0 gap-2">
              <button
                onClick={() => onTransfer(m.user_id, m.display_name)}
                className="rounded-lg border border-border-subtle bg-surface px-2.5 py-1 text-xs text-text-primary"
              >
                Make owner
              </button>
              <button
                onClick={() => onRemove(m.user_id, m.display_name)}
                className="rounded-lg border border-rose/40 bg-rose/10 px-2.5 py-1 text-xs text-rose"
              >
                Remove
              </button>
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
